module.exports = __webpack_public_path__ + "1cc108566965fb69fdb7f162ad31561c.png";